import { mpEventInfo } from '@/constant'
import type { DefaultResponse } from '@/types/common'
import maxios from '@/utils/axios/maxios'

// 과금 API
const paymentApi = {
  // 과금 기본 정보 가져오기
  getAcademyPayment(yearDashMonth: string) {
    return maxios.get<DefaultResponse<res.AcademyPayment>>('/payments/academies', {
      params: { yearMonth: yearDashMonth, mp_event_name: mpEventInfo.학원과금정보조회 },
    })
  },
  // 추가요금 및 대상 학생 목록을 가져오기
  getAcademyStudentPayments(params: { yearMonth: string }) {
    return maxios.get<DefaultResponse<res.StudentPayment[]>>(`/payments/academies/students`, {
      params: {
        ...params,
        mp_event_name: mpEventInfo.추가요금조회,
      },
    })
  },
  // 문자 과금 정보 가져오기
  getAcademyPaymentMessage(pageQueryString: string, dateParams) {
    return maxios.get<DefaultResponse<res.PaymentMessageStatus>>(
      `/payments/academies/messages${pageQueryString}`,
      { params: { ...dateParams, mp_event_name: mpEventInfo.문자과금조회 } },
    )
  },
}
export default paymentApi
